import React from 'react';

function SortPopover({
  isOpen,
  onClose,
  sortRules,
  sortableColumns,
  sortTypes,
  onSortRuleChange,
  onAddSortRule,
  onRemoveSortRule,
  isMobile,
}) {
  if (!isOpen) return null;

  return (
    <div
      className="card shadow-sm"
      style={{
        position: 'absolute',
        top: '100%',
        right: 0,
        left: 'auto',
        zIndex: 1050,
        minWidth: isMobile ? 280 : 420,
        marginTop: 4,
      }}
    >
      <div className="card-body p-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <span className="font-weight-bold">Sort by</span>
          <button
            type="button"
            className="btn btn-link btn-sm p-0 text-muted"
            onClick={onClose}
          >
            <i className="fal fa-times" />
          </button>
        </div>
        {sortRules.map((rule, index) => {
          const col = sortableColumns.find((c) => c.id === rule.field);
          const sortType = col?.sortType || 'text';
          const dirLabels = (sortTypes && sortTypes[sortType]) || sortTypes?.text || { asc: 'A \u2192 Z', desc: 'Z \u2192 A' };
          return (
            <div key={index} className="d-flex align-items-center gap-2 mb-2">
              <select
                className="form-control form-control-sm"
                style={{ flex: '1 1 0' }}
                value={rule.field}
                onChange={(e) => onSortRuleChange(index, 'field', e.target.value)}
              >
                {sortableColumns.map((c) => (
                  <option
                    key={c.id}
                    value={c.id}
                    disabled={sortRules.some((r, i) => i !== index && r.field === c.id)}
                  >
                    {c.label}
                  </option>
                ))}
              </select>
              <select
                className="form-control form-control-sm"
                style={{ flex: '1 1 0' }}
                value={rule.direction}
                onChange={(e) => onSortRuleChange(index, 'direction', e.target.value)}
              >
                <option value="asc">{dirLabels.asc}</option>
                <option value="desc">{dirLabels.desc}</option>
              </select>
              <button
                type="button"
                className="btn btn-link btn-sm p-0 text-muted"
                onClick={() => onRemoveSortRule(index)}
                disabled={sortRules.length <= 1}
                style={{ opacity: sortRules.length <= 1 ? 0.3 : 1 }}
              >
                <i className="fal fa-times" />
              </button>
            </div>
          );
        })}
        {sortRules.length < sortableColumns.length && (
          <button
            type="button"
            className="btn btn-link btn-sm p-0 text-primary"
            onClick={onAddSortRule}
          >
            <i className="fal fa-plus mr-1" />
            Add another sort
          </button>
        )}
      </div>
    </div>
  );
}

export default SortPopover;
